import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export interface KioskBackgroundCustomProps extends SvgIconProps {
  readonly fill?: string
}

const KioskBackgroundCustom = forwardRef<
SVGSVGElement,
KioskBackgroundCustomProps
>(function KioskBackgroundCustom({ fill, ...rest }, ref) {
  return (
    <SvgIcon
      height="428px"
      ref={ref}
      viewBox="0 0 1024 428"
      width="1024px"
      {...rest}
    >
      <path
        d="M1205 304v464c-292.383202-122.33301-463.000461-99.114151-730.188794-55.566252C219.209872 754.09313-22.3305153 724.064309-151 653.275632V304h1356z"
        fill={fill}
        fillRule="evenodd"
        transform="rotate(180 527 366)"
      />
    </SvgIcon>
  )
})

export default KioskBackgroundCustom
